module.exports = __webpack_public_path__ + "static/media/feedSolutions.72d92898.svg";